// const mxModule = require("mxgraph")();
// const {
//     mxCylinder, mxPoint, mxConnectionConstraint, mxConstants
//   } = mxModule;
import { mxCylinder, mxPoint, mxConnectionConstraint, mxConstants } from "../utils/graph/mxModule";

function vddShape() { }
    vddShape.prototype = new mxCylinder();
    vddShape.prototype.constructor = vddShape;

    vddShape.prototype.constraints = [
        new mxConnectionConstraint(new mxPoint(0.5, 1), true),  // VDD
      ];

    vddShape.prototype.paintVertexShape = function (c, x, y, w, h) {
        // Scale SVG's 48x42 viewBox to actual w/h
        const scaleX = w / 48;
        const scaleY = h / 42;
      
        // === Draw the horizontal green line ===
        c.setStrokeColor('#00cc66');
        c.setStrokeWidth(2);
        c.begin();
        c.moveTo(x + 0 * scaleX, y + 0 * scaleY);
        c.lineTo(x + 48 * scaleX, y + 0 * scaleY);
        c.stroke();
      
        // === Draw the vertical green line ===
        c.begin();
        c.moveTo(x + 24 * scaleX, y + 0 * scaleY);
        c.lineTo(x + 24 * scaleX, y + 42 * scaleY);
        c.stroke();
      
        // === Draw "VDD" text in red ===
        c.setFontColor('#fd0000');
        c.setFontSize(9 * scaleX); // adjust font size to scale
        c.setFontFamily('Arial');
        c.text(x + 36 * scaleX, y + 10 * scaleY, 0, 0, 'VDD', mxConstants.ALIGN_CENTER, mxConstants.ALIGN_MIDDLE, false, null, 0, 0, 0);
      };

    export default vddShape